'use client'

import { cn } from '@tebuto/lib/utils'
import { tebutoFounder, tebutoTeam } from '@/config/seo/general'
import { JsonLDPerson } from '@/config/seo/types'
import { useEasterEgg } from '../hooks'

interface TeamMember {
    name: string
    role: string
    image: string
    linkedIn: string
}

const team: TeamMember[] = tebutoFounder.concat(tebutoTeam).map((entry) => {
    const member = entry as JsonLDPerson

    return {
        name: member.name,
        role: member.jobTitle,
        image: member.image,
        linkedIn: member.sameAs[0] // Note: This could be an issue if we extend this
    }
})

const teamEasterEgg = [
    {
        name: 'Jonas Scholl',
        role: 'Mitgründer & Software Engineer',
        image: '/assets/jonas-easteregg.gif',
        linkedIn: 'https://www.linkedin.com/in/jonas-scholl-4a1047205'
    },
    {
        name: 'Yannic Schröer',
        role: 'Mitgründer & Software Engineer',
        image: '/assets/yannic.webp',
        linkedIn: 'https://www.linkedin.com/in/yannic-schroeer/'
    }
]

export default function Team() {
    const { easterEggEnabled } = useEasterEgg('666', 0.5)

    return (
        <div className="grid sm:grid-cols-2 gap-6 max-w-2xl">
            {(easterEggEnabled ? teamEasterEgg : team).map((member) => (
                <TeamMemberItem key={member.name} {...member} />
            ))}
        </div>
    )
}

function TeamMemberItem({ name, role, image, linkedIn }: TeamMember) {
    return (
        <article className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <img src={image} alt={name} className="aspect-[4/5] w-full object-cover" />

            <div className="flex items-start justify-between gap-3 border-t border-gray-100 bg-gray-50 px-4 py-4">
                <div className="min-w-0">
                    <p className="text-lg font-semibold leading-snug text-gray-900">{name}</p>
                    <p className="mt-1 text-sm leading-relaxed text-gray-600">{role}</p>
                </div>
                <a
                    href={linkedIn}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={`${name} auf LinkedIn`}
                    className={cn(
                        'flex size-10 shrink-0 items-center justify-center rounded-md text-primary-700',
                        'transition-colors hover:bg-primary-100 hover:text-primary-800',
                        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2'
                    )}
                >
                    <svg fill="currentColor" viewBox="0 0 24 24" className="size-5" aria-hidden="true">
                        <path
                            fillRule="evenodd"
                            d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                            clipRule="evenodd"
                        />
                    </svg>
                </a>
            </div>
        </article>
    )
}
